import { get, post, put, remove } from '../../api';
import { Store } from 'react-notifications-component';
import {
  COMMON_DATA_DELETE_FAIL,
  COMMON_DATA_DELETE_SUCCESS,
  COMMON_DATA_UPDATE_FAIL,
  COMMON_DATA_UPDATE_SUCCESS,
} from '../../constants/notification-settings';

export const FETCH_BLOCKS_START = 'FETCH_BLOCKS_START';
export const FETCH_BLOCKS_SUCCESS = 'FETCH_BLOCKS_SUCCESS';
export const FETCH_BLOCKS_FAIL = 'FETCH_BLOCKS_FAIL';

export const FETCH_BLOCK_START = 'FETCH_BLOCK_START';
export const FETCH_BLOCK_SUCCESS = 'FETCH_BLOCK_SUCCESS';
export const FETCH_BLOCK_FAIL = 'FETCH_BLOCK_FAIL';

export const CREATE_BLOCK_START = 'CREATE_BLOCK_START';
export const CREATE_BLOCK_SUCCESS = 'CREATE_BLOCK_SUCCESS';
export const CREATE_BLOCK_FAIL = 'CREATE_BLOCK_FAIL';

export const UPDATE_BLOCK_START = 'UPDATE_BLOCK_START';
export const UPDATE_BLOCK_SUCCESS = 'UPDATE_BLOCK_SUCCESS';
export const UPDATE_BLOCK_FAIL = 'UPDATE_BLOCK_FAIL';

export const UPDATE_BLOCK_IMAGE_START = 'UPDATE_BLOCK_IMAGE_START';
export const UPDATE_BLOCK_IMAGE_SUCCESS = 'UPDATE_BLOCK_IMAGE_SUCCESS';
export const UPDATE_BLOCK_IMAGE_FAIL = 'UPDATE_BLOCK_IMAGE_FAIL';

export const DELETE_BLOCK_START = 'DELETE_BLOCK_START';
export const DELETE_BLOCK_SUCCESS = 'DELETE_BLOCK_SUCCESS';
export const DELETE_BLOCK_FAIL = 'DELETE_BLOCK_FAIL';

export const UPDATE_BLOCKS_POSITION = 'UPDATE_BLOCKS_POSITION';

const fetchBlocksStart = () => ({
  type: FETCH_BLOCKS_START,
});

export const fetchBlocksSuccess = (payload) => ({
  type: FETCH_BLOCKS_SUCCESS,
  payload,
});

const fetchBlocksFail = (error) => ({
  type: FETCH_BLOCKS_FAIL,
  payload: error,
});

export const fetchBlocks = (props) =>
  async (dispatch) => {
    dispatch(fetchBlocksStart());
    try {
      const params = new URLSearchParams();
      // eslint-disable-next-line array-callback-return
      Object.keys(props).map((key) => {
        // eslint-disable-next-line no-unused-expressions
        props[key] && params.append(key, props[key]);
      });
      const result = await get(
        `/blocks?${params}`,
      );
      dispatch(fetchBlocksSuccess(Array.isArray(result.data?.items) ? result.data.items : []));
      return result.data;
    } catch (e) {
      dispatch(fetchBlocksFail(e));
      return null;
    }
  };

const fetchBlockStart = (id) => ({
  type: FETCH_BLOCK_START,
  payload: id,
});

const fetchBlockSuccess = (payload) => ({
  type: FETCH_BLOCK_SUCCESS,
  payload,
});

const fetchBlockFail = (error) => ({
  type: FETCH_BLOCK_FAIL,
  payload: error,
});

export const fetchBlock = (id) => async (dispatch) => {
  dispatch(fetchBlockStart());
  try {
    const result = await get(`/blocks/${id}`);
    dispatch(fetchBlockSuccess(result.data));
    return result.data;
  } catch (e) {
    dispatch(fetchBlockFail(e));
    return null;
  }
};

const createBlockStart = () => ({
  type: CREATE_BLOCK_START,
});

const createBlockSuccess = (payload) => ({
  type: CREATE_BLOCK_SUCCESS,
  payload,
});

const createBlockFail = (error) => ({
  type: CREATE_BLOCK_FAIL,
  payload: error,
});

export const createBlock = (block, translations) => async (dispatch) => {
  dispatch(createBlockStart());
  try {
    const result = await post('/blocks', block);
    if (result?.data) {
      dispatch(createBlockSuccess(result?.data));
      Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
      return result.data;
    }
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    return null;
  } catch (e) {
    dispatch(createBlockFail(e));
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    return null;
  }
};

const updateBlockStart = () => ({
  type: UPDATE_BLOCK_START,
});

const updateBlockSuccess = (payload) => ({
  type: UPDATE_BLOCK_SUCCESS,
  payload,
});

export const updateBlocksPosition = (payload) => ({
  type: UPDATE_BLOCKS_POSITION,
  payload,
});

const updateBlockFail = (error) => ({
  type: UPDATE_BLOCK_FAIL,
  payload: error,
});

export const updateBlock = (block, lang, translations, silent = true) =>
  async (dispatch) => {
    dispatch(updateBlockStart());
    try {
      const result = await put(`/blocks/${block.id}?langCode=${lang}`, block);
      dispatch(updateBlockSuccess(result));
      if (!silent) {
        Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
      }
      return true;
    } catch (e) {
      dispatch(updateBlockFail(e));
      Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
      return false;
    }
  };

export const changeVisible = (block) => async (dispatch) => {
  try {
    const result = await put(`/blocks/${block.id}/change-visibility`, {});
    if (result?.data === true) {
      dispatch(updateBlockSuccess({ ...block, isVisible: !block.isVisible }));
    }
    return !!result?.data;
  } catch (e) {
    return false;
  }
};

const updateBlockImageStart = () => ({
  type: UPDATE_BLOCK_IMAGE_START,
});

const updateBlockImageSuccess = (payload) => ({
  type: UPDATE_BLOCK_IMAGE_SUCCESS,
  payload,
});

const updateBlockImageFail = (error) => ({
  type: UPDATE_BLOCK_IMAGE_FAIL,
  payload: error,
});

export const updateBlockImage = (blockId, image, translations) => async (dispatch) => {
  dispatch(updateBlockImageStart());
  try {
    await put(`/blocks/image/${blockId}`, image);
    dispatch(updateBlockImageSuccess());
    dispatch(fetchBlocks());
    Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
  } catch (e) {
    dispatch(updateBlockImageFail(e));
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
  }
};

const deleteBlockStart = () => ({
  type: DELETE_BLOCK_START,
});

const deleteBlockSuccess = (payload) => ({
  type: DELETE_BLOCK_SUCCESS,
  payload,
});

const deleteBlockFail = (error) => ({
  type: DELETE_BLOCK_FAIL,
  payload: error,
});

export const deleteBlock = (id, translations) => async (dispatch) => {
  dispatch(deleteBlockStart());
  try {
    await remove(`/blocks/${id}`);
    dispatch(deleteBlockSuccess(id));
    Store.addNotification(COMMON_DATA_DELETE_SUCCESS(translations));
  } catch (e) {
    dispatch(deleteBlockFail(e));
    Store.addNotification(COMMON_DATA_DELETE_FAIL(translations));
  }
};

/**
 * Запрос превью товаров блока через admin endpoint
 * `GET /api/admin/blocks/:id/preview`. Возвращает объект
 * `{ items, total, appliedAudienceRule, warnings, explain, error, permissionMissing }`.
 *
 * `params` — query-параметры (`langCode`, `targetProductId`, `simulatedUserId`,
 * `ageOverride`, `userAttributeOverride`, `limit`, `offset`).
 *
 * Возвращает объектом, чтобы вызывающий код мог распаковать `items`/`total`
 * без лишних обращений к response shape (правило `feedback_return_braces`).
 *
 * 403-обработка (spec AC#15, review feedback round 1): если seed
 * permission `blocks.preview` ещё не прогнан на окружении (распространённая
 * проблема после merge'а нового permission'а), backend вернёт 403. В этом
 * случае мы выставляем `permissionMissing: true` — потребитель (UI) должен
 * показать понятный warning-banner с инструкцией `npm run typeorm:seed:run`,
 * вместо generic «Failed to load preview». Это сильно ускоряет диагностику
 * на dev/stage-окружениях и убирает «магию» с пустой таблицей превью.
 *
 * `explain` намеренно НЕ приводится к `[]` через `??` — backend отличает
 * `undefined` (контекста не хватило, причины не считались) от `[]` у
 * конкретного товара (причины считались, но их нет). Схлопнув в `[]` здесь,
 * мы бы стёрли это различие для UI (Explanation-таба).
 */
export const previewBlock = (blockId, params = {}) => async () => {
  try {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') return;
      search.append(key, String(value));
    });
    const result = await get(`/blocks/${blockId}/preview?${search.toString()}`);
    return {
      items: result?.data?.items || [],
      total: result?.data?.total || 0,
      appliedAudienceRule: result?.data?.appliedAudienceRule || null,
      warnings: result?.data?.warnings || [],
      fallbackUsed: result?.data?.fallbackUsed ?? null,
      contextEcho: result?.data?.contextEcho ?? null,
      explain: result?.data?.explain,
      error: null,
      permissionMissing: false,
    };
  } catch (e) {
    // 403 = permission `blocks.preview` отсутствует у текущего админа.
    // Чаще всего — не прогнан typeorm seed после merge'а нового permission'а.
    // Мы НЕ показываем generic toast, а возвращаем отдельный флаг, чтобы
    // вызывающий компонент отрендерил специальный warning-баннер с готовой
    // инструкцией для разработчика.
    const status = e && e.response && e.response.status;
    const permissionMissing = status === 403;
    return {
      items: [],
      total: 0,
      appliedAudienceRule: null,
      warnings: [],
      fallbackUsed: null,
      contextEcho: null,
      explain: undefined,
      error: e,
      permissionMissing,
    };
  }
};

/**
 * Диагностика схлопывания похожих товаров —
 * `GET /api/admin/blocks/:id/similar-diagnostics`.
 *
 * Отдаёт `{ productCount, modelCount, shortBlockProductCount, warnings }`.
 * Это справочные цифры под формой, а не валидация: они не блокируют
 * сохранение и не прячут блок. Поэтому ошибка запроса гасится в `error`,
 * а счётчики возвращаются `null` — подписи просто не отрисуются.
 */
export const fetchSimilarDiagnostics = (blockId, params = {}) => async () => {
  try {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') return;
      search.append(key, String(value));
    });
    const result = await get(`/blocks/${blockId}/similar-diagnostics?${search.toString()}`);
    return {
      productCount: result?.data?.productCount ?? null,
      modelCount: result?.data?.modelCount ?? null,
      shortBlockProductCount: result?.data?.shortBlockProductCount ?? null,
      warnings: result?.data?.warnings || [],
      error: null,
    };
  } catch (e) {
    return {
      productCount: null,
      modelCount: null,
      shortBlockProductCount: null,
      warnings: [],
      error: e,
    };
  }
};
